import { DepartmentModel } from 'api/dto/Department.dto';

export const findSiblingsInDepartmentsTree = (
  departments: DepartmentModel[],
  departmentId: number,
): DepartmentModel[] => {
  if (departments.some((department) => department.id === departmentId)) {
    return departments;
  } else {
    return departments.reduce(
      (siblings, department) =>
        siblings || findSiblingsInDepartmentsTree(department.children, departmentId),
      undefined,
    ) as DepartmentModel[];
  }
};
